import {useLocation} from '@github-ui/react-router'

import {repoSidebarLinks} from './repos-issues-sidebar-links'

export function useIssuesSidebarState() {
  const {pathname, search} = useLocation()

  const searchParams = new URLSearchParams(search)
  const currentQuery = searchParams.get('q')?.trim()
  const currentQueryMatch = repoSidebarLinks.find(link => link.query === currentQuery)

  const isOnIssuesPage = /\/issues\/?$/.test(pathname)
  const defaultLink = isOnIssuesPage ? repoSidebarLinks.find(link => link.id === 'issues') : undefined
  const selectedLink = currentQueryMatch?.id ?? defaultLink?.id ?? ''

  return {selectedLink}
}
